import React from 'react';
import { Redirect } from 'react-router-dom';
import stores from '../../stores';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import ErrorDetails from '../portal/errorDetails';
import Permissions from '../../services/enums/permissions';

const authorize = (allowedPermissions, accessDeniedBehavior = AccessDeniedBehavior.hide, to) => (WrappedComponent) => {
  
  return class extends React.Component {

    constructor(props) {
      super(props)
      this.displayName = `authorize(${this.getDisplayName(WrappedComponent)})`;
    }
    
    getDisplayName = (WrappedComponent) => {
      return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }

    isUserAllowd = () => {
        
      let isUserAllowd = false;
      
      if(allowedPermissions)
      {
        isUserAllowd = this.userHasAnyAllowedPermissions(allowedPermissions);
      }
      else if(this.props.allowedPermissions)
      {
        isUserAllowd = this.userHasAnyAllowedPermissions(this.props.allowedPermissions);
      }
      
      return isUserAllowd;
    }
  

    userHasAnyAllowedPermissions = (allowedPermissions) => {
            
      if(allowedPermissions.indexOf(Permissions.allowAll) > -1) return true;

      for (var i = 0; i < allowedPermissions.length; i++) {
        if (this.isUserPermissionsInclude(allowedPermissions[i])) {
            return true;
        }
      }

      return false;
    }

    isUserPermissionsInclude = (allowedPermission) => {
      
        const userPermissions = stores.oidcStore.currentUser.profile['access-control-permissions'];
        
        if(!userPermissions) {
          
          return false;
        }
        
        if(typeof userPermissions === 'string') {
          
          return userPermissions === allowedPermission;
        }

        for (var i = 0; i < userPermissions.length; i++) {

          if (userPermissions[i] === allowedPermission) {
              return true;
          }
        }
        
        return false;
    }
  
    render() {
      if (this.isUserAllowd()) {
        return <WrappedComponent {...this.props} />
      } else {
        switch(accessDeniedBehavior) {
          case AccessDeniedBehavior.displayError:
              return <div className='error-wrapper'>
                        <ErrorDetails
                          error={stores.translationsStore.translate('ACCESS_DENIED_TITLE')}
                          errorDescription={stores.translationsStore.translate('ACCESS_DENIED_SUB_TITLE')}>
                        </ErrorDetails>
                      </div>
          case AccessDeniedBehavior.redirect:
              return <Redirect to={to} />;     
          case AccessDeniedBehavior.hide:
          default:
            return null;
        }
      }
    }
  }
}

export default authorize


// WEBPACK FOOTER //
// ./src/components/authorization/authorize.jsx